import { render } from "./OtaCarousel.vue?vue&type=template&id=1649f6ba"
import script from "./OtaCarousel.vue?vue&type=script&lang=js"
export * from "./OtaCarousel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__